import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader } from "../../_metronic/_partials/controls";
import { useSubheader } from "../../_metronic/layout";
import { baseURLV1 } from "../service/API.js";
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Chart from "react-apexcharts";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
} from "../../_metronic/_helpers";
import "./style.css";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as XLSX from "xlsx";
import GraphSales from "./component/Chart/graphSales";
import GraphCustomer from "./component/Chart/graphCustomer";
import GraphVisitor from "./component/Chart/graphVisitor";
import GraphPie from "./component/Chart/graphPie";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 3,
  },
  papers: {
    padding: theme.spacing(2),
    marginBottom: "20px",
    marginTop: "20px",
  },
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    marginBottom: "20px",
    marginTop: "20px",
    maxWidth: "500px",
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
}));

const Data = [
  {
    id: 1,
    year: 2016,
    userGain: 80000,
    userLost: 823,
  },
  {
    id: 2,
    year: 2017,
    userGain: 45677,
    userLost: 345,
  },
  {
    id: 3,
    year: 2018,
    userGain: 78888,
    userLost: 555,
  },
  {
    id: 4,
    year: 2019,
    userGain: 90000,
    userLost: 4555,
  },
  {
    id: 5,
    year: 2020,
    userGain: 4300,
    userLost: 234,
  },
];

export const DashboardPage = (props) => {
  const { user } = useSelector((state) => state.auth);
  const [allData, setAlldata] = useState([]);
  const { authToken, accessTokenPrivilege } = useSelector(
    (state) => state.auth
  );

  const suhbeader = useSubheader();
  var d = new Date();
  d.setDate(d.getDate() - 30);
  const classes = useStyles();
  suhbeader.setTitle("Dashboard Page");
  useEffect(() => {
    getData();
  }, []);

  const [summary_data, setSummary_data] = useState([]);
  const [order_smmary, setOrder_smmary] = useState([]);
  const [top_sell_menu, setTop_sell_menu] = useState([]);
  const [customer_amount, setCustomer_amount] = useState([]);
  const [sell_chart, setSell_chart] = useState([]);
  const [customer_group, setCustomer_group] = useState([]);
  const [visitor, setVisitor] = useState([]);
  const [pie_percent, setPie_percent] = useState([]);
  const [lasted_transaction, setLasted_transaction] = useState([]);

  const getData = async (page, limit, search) => {
    let token = localStorage.getItem("posToken");
    axios({
      method: "get",
      url: `${baseURLV1}/fixedDashboard`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    }).then((res) => {
      if (res.message) {
        //history.push("/logout");
      } else {
        console.log(res.data.data);
        let data1 = res.data.data.filter((x) => x.name == "summary_data");
        let data2 = res.data.data.filter((x) => x.name == "order_smmary");
        let data3 = res.data.data.filter((x) => x.name == "top_sell_menu");
        let data4 = res.data.data.filter((x) => x.name == "customer_amount");
        let data5 = res.data.data.filter((x) => x.name == "sell_chart");
        let data6 = res.data.data.filter((x) => x.name == "customer_group");
        let data7 = res.data.data.filter((x) => x.name == "visitor");
        let data8 = res.data.data.filter((x) => x.name == "pie_percent");
        let data9 = res.data.data.filter((x) => x.name == "lasted_transaction");
        setSummary_data(data1[0]);
        setOrder_smmary(data2[0]);
        setTop_sell_menu(data3[0]);
        setCustomer_amount(data4[0]);
        setSell_chart(data5[0]);
        setCustomer_group(data6[0]);
        setVisitor(data7[0]);
        setPie_percent(data8[0]);
        setLasted_transaction(data9[0]);
        setAlldata(res.data.data);
      }
      console.log(allData);
    });
  };

  let withCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  return (
    <>
      {allData.length > 0 && (
        <div class="container d-flex bg-opacity-0 fullbody">
          <div class="d-flex flex-column flex-row-auto w-50 mr-2 ml-2">
            <div className="">
              <section className="sec_netSales cardStyle bg-white mb-2">
                <a href="/" className={"btnMore"} />
                <div className="cardContent">
                  <h1 className="titleCard">
                    ยอดขายสุทธิ
                    <span>{withCommas(summary_data.data.sell_summary)}</span>บาท
                  </h1>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="detailItem">
                        <p>
                          {summary_data.data.previous_mount >= 0 ? (
                            <span className="txt-green">
                              +{withCommas(summary_data.data.previous_mount)}
                            </span>
                          ) : (
                            <span className="txt-red">
                              {withCommas(summary_data.data.previous_mount)}
                            </span>
                          )}
                          บาท
                        </p>
                      </div>
                      <div className="detailItem">
                        <p>เมื่อเทียบกับเดือนก่อนหน้า</p>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="detailItem">
                        ยอด Vat {summary_data.data.vat_rate}%
                        <p>
                          <span className="txt-purple2">
                            {withCommas(
                              summary_data.data.vat_amount
                            )}
                          </span>
                          บาท
                        </p>
                      </div>
                      <div className="detailItem">
                        รายรับรวม
                        <p>
                          <span className="txt-purple2">
                            {withCommas(summary_data.data.income)}
                          </span>
                          บาท
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="groupIcon">
                    <div className="iconItem">
                      <div className="picIcon">
                        <img
                          src="/media/icon/Order.png"
                          alt=""
                          width={25}
                          height={25}
                        />
                      </div>
                      <div className="iconDetail">
                        <h5>{withCommas(summary_data.data.order_amount)}</h5>
                        <p>Order</p>
                      </div>
                    </div>
                    <div className="iconItem">
                      <div className="picIcon">
                        <img
                          src="/media/icon/Customer.png"
                          alt=""
                          width={25}
                          height={25}
                        />
                      </div>
                      <div className="iconDetail">
                        <h5>
                          {withCommas(summary_data.data.custommer_amount)}
                        </h5>
                        <p>Customer</p>
                      </div>
                    </div>
                    <div className="iconItem">
                      <div className="picIcon">
                        <img
                          src="/media/icon/Visitor.png"
                          alt=""
                          width={25}
                          height={25}
                        />
                      </div>
                      <div className="iconDetail">
                        <h5>{withCommas(summary_data.data.visitor)}</h5>
                        <p>Visitor</p>
                      </div>
                    </div>
                    <div className="iconItem">
                      <div className="picIcon">
                        <img
                          src="/media/icon/Products.png"
                          alt=""
                          width={25}
                          height={25}
                        />
                      </div>
                      <div className="iconDetail">
                        <h5>{withCommas(summary_data.data.product)}</h5>
                        <p>Products</p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <div class="d-flex flex-column-fluid">
              <div class="d-flex flex-column flex-row-auto w-50 border">
                <div class="d-flex flex-column-fluid flex-center mr-2">
                  <section className="sec_sumOrder cardStyle mb-2">
                    <a href="/" className={"btnMore"} />
                    <div className="cardContent">
                      <h1 className="titleCard">
                        ออเดอร์รวม <br />
                        <span>
                          {withCommas(parseInt(order_smmary.data.bill_amount))}
                        </span>
                        บิล
                      </h1>
                      <div className="subDetail">
                        <p>
                          {order_smmary.data.bill_amount -
                            order_smmary.data.previous_bill_amount >=
                          0 ? (
                            <span className="txt-green txt-md">
                              +
                              {withCommas(
                                order_smmary.data.bill_amount -
                                  order_smmary.data.previous_bill_amount
                              )}
                            </span>
                          ) : (
                            <span className="txt-red txt-md">
                              
                              {withCommas(
                                order_smmary.data.bill_amount -
                                  order_smmary.data.previous_bill_amount
                              )}
                            </span>
                          )}
                          บิล
                          <span className="txt-gray">
                            เมื่อเทียบกับเดือนก่อนหน้า
                          </span>
                        </p>
                      </div>
                      <div className="detailItem">
                        ยอดเฉลี่ย
                        <p>
                          <span className="txt-purple2 txt-md">
                            {withCommas(order_smmary.data.bill_amount_average)}
                          </span>
                          บาท/บิล
                        </p>
                      </div>
                      <div className="detailItem">
                        เมนูเฉลี่ย
                        <p>
                          <span className="txt-purple2 txt-md">
                            {withCommas(order_smmary.data.average_menu_bill)}
                          </span>
                          บาท/บิล
                        </p>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              <div class="d-flex flex-column flex-row-auto w-50 border">
                <div class="d-flex flex-column-fluid flex-center">
                  <GraphPie visitor={visitor} pie_percent={pie_percent} />
                </div>
              </div>
            </div>
            <div class="d-flex flex-column-fluid">
              <div class="d-flex flex-column flex-row-auto w-50 border">
                <div class="d-flex flex-column-fluid mr-2 flex-center">
                  <section className="sec_sumCustomers cardStyle mb-2 w-100 h-100">
                    <a href="/" className={"btnMore"} />
                    <div className="cardContent">
                      <h1 className="titleCard">
                        จำนวนลูกค้า <br />
                        <span>{customer_amount.data.customer_count}</span>คน
                      </h1>
                      <div className="subDetail">
                        <p>
                          {customer_amount.data.previous_month_amount -
                            customer_amount.data.customer_count >=
                          0 ? (
                            <span className="txt-green txt-md">
                              +
                              {customer_amount.data.customer_count -
                                customer_amount.data.previous_month_amount}
                            </span>
                          ) : (
                            <span className="txt-red txt-md">
                              {customer_amount.data.customer_count -
                                customer_amount.data.previous_month_amount}
                            </span>
                          )}
                          คน
                          <span className="txt-gray">
                            เมื่อเทียบกับเดือนก่อนหน้า
                          </span>
                          <br />
                          เป็นลูกค้าเก่าเดือนที่แล้ว
                          <span className="txt-purple2 txt-md">
                            {customer_amount.data.previous_month_amount}
                          </span>
                          คน
                        </p>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
              <div class="d-flex flex-column flex-row-auto w-50 border">
                <div class="d-flex flex-column-fluid flex-center">
                  <section className="sec_bestSeller cardStyle mb-2 w-100 h-100">
                    <a href="/" className={"btnMore"} />
                    <div className="cardContent">
                      <h1 className="titleCard">เมนูขายดี</h1>
                      <div className="tableMenu">
                        <div className="menuItem">
                          <p className="txt-md">เมนู</p>
                          <p className="txt-md">ออเดอร์</p>
                        </div>
                        <div className="tableBody">
                          {top_sell_menu.data.map((item, i) => {
                            return (
                              <div className="menuItem">
                                <p>{item.name}</p>
                                <p>{item.order}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column-fluid">
              <div class="d-flex flex-column flex-row-auto w-50 border">
                <div class="d-flex flex-column-fluid  mr-2 flex-center">
                  <GraphVisitor visitor={visitor} pie_percent={pie_percent} />
                </div>
              </div>
              <div class="d-flex flex-column flex-row-auto w-50 border">
                <div class="d-flex flex-column-fluid  flex-center">
                  <GraphCustomer customer_group={customer_group} />
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column flex-row-auto w-50 mr-2 ml-2">
            <div class="d-flex ">
              <GraphSales sell_chart={sell_chart} />
            </div>
            <div class="d-flex ">
              <section className="sec_orderList cardStyle bg-white w-100 mb-2">
                <a href="/" className={"btnMore"} />
                <div className="cardContent">
                  <h1 className="titleCard">รายการสั่งซื้อ ล่าสุด</h1>
                  <div className="tableOrder">
                    {lasted_transaction.data.map((item, i) => {
                      return (
                        <div className="OrderItem">
                          <div className="pic">
                            <img src={item.pic} alt="" width={50} height={50} />
                          </div>
                          <div className="name noti">
                            <p>{item.name}</p>
                          </div>
                          <div className="date">
                            <p>{item.date}</p>
                          </div>
                          <div className="price">
                            <p>{item.price}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
